import { render, staticRenderFns } from "./ProjectInfoBar.vue?vue&type=template&id=0f3dc05a&scoped=true&"
import script from "./ProjectInfoBar.vue?vue&type=script&lang=js&"
export * from "./ProjectInfoBar.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInfoBar.vue?vue&type=style&index=0&id=0f3dc05a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3dc05a",
  null
  
)

export default component.exports